import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "user-onboarding-create-profile" }
const _hoisted_2 = { class: "grid" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "user-onboarding-create-profile__actions" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Continue ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountPictureUpload = _resolveComponent("AccountPictureUpload")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_AppSelect = _resolveComponent("AppSelect")!
  const _component_AppDropdown = _resolveComponent("AppDropdown")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AccountPictureUpload, {
      id: "onboarding-profile-picture",
      defaultAvatar: require('@/assets/images/default-avatar.png'),
      class: "user-onboarding-cards__picture-upload",
      title: "Add profile picture",
      variation: "simple",
      isNewUser: ""
    }, null, 8, ["defaultAvatar"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.inputs, (input) => {
        return (_openBlock(), _createElementBlock("div", {
          key: input.id,
          class: "col-6"
        }, [
          (input.label === 'Country')
            ? (_openBlock(), _createBlock(_component_AppDropdown, {
                key: 0,
                type: "simple"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(input.label), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_AppSelect, {
                    modelValue: _ctx.country,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.country) = $event)),
                    options: _ctx.countries,
                    "visible-options": _ctx.visibleCountries,
                    min: 1,
                    "close-on-select": true,
                    "onSearch:input": _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCountriesOnSearch($event.target.value))),
                    "clear-on-close": "",
                    searchable: "",
                    placeholder: 'Select country',
                    "open-direction": "top",
                    onBlur: _ctx.checkForEmptyErrorsOnCurrentStep
                  }, {
                    toggle: _withCtx(({ isFocusing, toggle }) => [
                      _createElementVNode("div", {
                        onClick: toggle,
                        onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent","stop"])),
                        class: _normalizeClass(["app-dropdown__vue-select-trigger", { active: isFocusing }])
                      }, [
                        _createVNode(_component_AppIcon, { name: "arrow" })
                      ], 42, _hoisted_3)
                    ]),
                    label: _withCtx(({ selected }) => [
                      _createTextVNode(_toDisplayString(selected ? selected : 'Select country'), 1)
                    ]),
                    "dropdown-item": _withCtx(({ option }) => [
                      _createElementVNode("p", null, _toDisplayString(option), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "visible-options", "onBlur"])
                ]),
                _: 2
              }, 1024))
            : (input.label === 'City')
              ? (_openBlock(), _createBlock(_component_AppDropdown, {
                  key: 1,
                  type: "simple",
                  disabled: _ctx.cities.length === 0
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(input.label), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_AppSelect, {
                      modelValue: _ctx.city,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.city) = $event)),
                      options: _ctx.cities,
                      min: 1,
                      "clear-on-close": "",
                      "close-on-select": true,
                      searchable: _ctx.cities.length > 0,
                      "open-direction": "top",
                      placeholder: 'Select city',
                      onBlur: _ctx.checkForEmptyErrorsOnCurrentStep
                    }, {
                      toggle: _withCtx(({ isFocusing, toggle }) => [
                        _createElementVNode("div", {
                          onClick: toggle,
                          onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent","stop"])),
                          class: _normalizeClass(["app-dropdown__vue-select-trigger", { active: isFocusing }])
                        }, [
                          _createVNode(_component_AppIcon, { name: "arrow" })
                        ], 42, _hoisted_4)
                      ]),
                      label: _withCtx(({ selected }) => [
                        _createTextVNode(_toDisplayString(selected ? selected : 'Select city'), 1)
                      ]),
                      "dropdown-item": _withCtx(({ option }) => [
                        _createElementVNode("p", null, _toDisplayString(option), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options", "searchable", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["disabled"]))
              : (_openBlock(), _createBlock(_component_AppInput, {
                  key: 2,
                  modelValue: _ctx.userFields[input.name],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.userFields[input.name]) = $event),
                  id: input.id,
                  label: input.label,
                  placeholder: input.placeholder,
                  type: input.type,
                  maxlength: input.maxLength,
                  error: _ctx.fieldEmptyErrors[input.name] || !!_ctx.specialErrors[input.name],
                  onInput: _ctx.checkForEmptyErrorsOnCurrentStep
                }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "label", "placeholder", "type", "maxlength", "error", "onInput"]))
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_AppButton, {
        disabled: _ctx.buttonIsDisabled,
        loading: _ctx.loading,
        onClick: _ctx.updateUserProfile
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["disabled", "loading", "onClick"])
    ])
  ]))
}